module.exports = __webpack_public_path__ + "img/horizontal-bar-chart-02.5d2acf10.svg";